import { render, staticRenderFns } from "./MensageriaAutomacao.vue?vue&type=template&id=82998eca&scoped=true"
import script from "./MensageriaAutomacao.vue?vue&type=script&lang=js"
export * from "./MensageriaAutomacao.vue?vue&type=script&lang=js"
import style0 from "./MensageriaAutomacao.vue?vue&type=style&index=0&id=82998eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82998eca",
  null
  
)

export default component.exports